

export class CustomerInfoEcontrcatTable {
    public static clientsEcontrat: any = [
        {
            id: 1,
            postCode: '13011',
            address2: '',
            createdDate: '2019-06-26 01:46:48',
            sign: '',
            address3: 'ZAC LA VALENTINE',
            extRef: '1136245',
            language: 'France',
            lastModifiedDate: '2020-10-17 19:49:56',
            nafCode: '6630Z',
            customerName: 'GROUPE OMNIUM DEVELOPPEMENT',
            commercialName: 'GROUPE OMNIUM DEVELOPPEMENT',
            address1: '117 TRAVERSE DE LA MONTRE',
            country: 'FR',
            countryAdress: 'FRANCE',
            customerNationalId: '81961767100022',
            customerNationalIdInProgress: false,
            phoneNumber: '0491879205',
            city: 'MARSEILLE',
            source: 'Econtrat'
        }
    ];

}
